import { Alert } from "@mui/material";
import ContentCopy from "../ContentCopy";

interface Props {
  text: string;
  copyText: string;
  contentType?: string;
}

const AlertWithCopy = ({ copyText, text, contentType }: Props) => {
  return (
    <Alert severity="info">
      {text} <ContentCopy text={copyText} contentType={contentType} />
    </Alert>
  );
};

export default AlertWithCopy;
